import Store from "@/store";
import clear_all_videos from "@/router/modules/methods/clear_all_videos";

export default {
    path: '/add-ending',
    name: 'Add-Ending',
    component: () => import('@/views/add_ending/index.vue'),
    meta: {
        title: 'Добавление концовки',
        forVisitors: true
    },
    beforeEnter: async (to, from, next) => {
        await clear_all_videos()
        let entry = false;
        let main = false;
        let text = false;
        let ending = false;

        if(Store.getters['entry_video/entry'].length > 0) {
            entry = true
        }

        await Store.getters['main_videos/main'].forEach(item => {

            if (item.control === 'main') {
                main = true
            }

            if(item.type === 'text') {
                text = true
            }

        })

        if(await Store.getters['ending_video/ending'].length > 0) {
            ending  = true
        }


        if(entry && main && text) {
            if(ending) {
                next({name: 'Survey'})
            } else {
                next()
            }
        } else {
            next({name: 'Theme'})
        }
    }
}